export type SidebarChildItemConfig = {
  active: boolean;
  disabled?: boolean;
  dotStatus?: 'success' | 'warning' | null;
  errorCount?: number;
  icon?: string;
  id: string;
  onSubsectionClick: (subsectionId: string) => void;
  show?: boolean;
  text: string;
};

export type SidebarChildGroup = {
  label: string;
  items: SidebarChildItemConfig[];
};

export type SidebarMainItemConfig<T> = {
  checked: boolean;
  children?: (SidebarChildItemConfig | SidebarChildGroup)[];
  enabled: boolean;
  icon: string;
  id: T;
  onSectionClick: (sectionId?: T) => void;
  text: string;
};

export type SidebarConfig<T> = SidebarMainItemConfig<T>[];

export function isChildGroup(item: SidebarChildItemConfig | SidebarChildGroup): item is SidebarChildGroup {
  return 'items' in item;
}
